import React, { useContext, useEffect } from 'react';
import { Card, CardContent, CardHeader, IconButton, Tooltip, Box, Typography } from '@material-ui/core';
import { Panel } from '../../../../../Components/Panel/Panel';
import { useIntl } from 'react-intl';
import { Form, HtmlView, Loading } from '../../../../../Components';
import { useFormField } from '../../../../../Components/Form/FormField';
import { Edit } from '@material-ui/icons';
import { set } from 'lodash';
import { useAptorApi } from '../../../../../Api';
import { Module, UserContext } from '../../../../../Context/UserContext/UserContext';
import { EvaluationInfoEnum } from '../../../../../Context/EvaluationInfoEmun';

const OtherRequirementInfo = ({ otherRequirementStepInfo, currentStepName, onUpdate }: any) => {
    const { formatMessage } = useIntl();
    const [editMode, setEditMode] = React.useState(false);
    const { api } = useAptorApi();
    const { customerId,locale,hasAccessToModule } = useContext(UserContext);
    const [submitting, setSubmitting] = React.useState(false);

    const handleSubmit = async (formData: any) => {
        setSubmitting(true);
        try {
            const payload = {
                type: EvaluationInfoEnum.otherRequirementInfo,
                data:{
                ...otherRequirementStepInfo,
                [currentStepName]: {
                    otherRequirementInformationSv: formData.otherRequirementInformationSv || '',
                    otherRequirementInformationEn: formData.otherRequirementInformationEn || '',
                }
            },
            };

            await api.updateLawportalevaluationStepSettings(payload);

            if (onUpdate) {
                onUpdate();
            }

            setEditMode(false);
        } catch (error) {
            console.error('Error updating evaluation step settings:', error);
        } finally {
            setSubmitting(false);
        }
    };
    return (
        <Panel
            title={formatMessage({ id: 'law-portal.our-Law.info-other-req-checklist.header' })}
            style={{ width: '100%', boxSizing: 'border-box', backgroundColor: "#f7f0f1", }}
            rightComponent={
                !editMode&&hasAccessToModule(Module.Administration) && (
                    <Tooltip title={formatMessage({ id: 'utils.icon.edit', defaultMessage: 'Edit' })}>
                        <IconButton
                            aria-label={formatMessage({ id: 'utils.icon.edit', defaultMessage: 'Edit' })}
                            onClick={() => setEditMode(true)}
                        >
                            <Edit fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )
            }
        >
            {editMode ? (
                <EvaluationForm
                    editingData={otherRequirementStepInfo?.[currentStepName]}
                    submit={handleSubmit}
                    cancelEdit={() => { setEditMode(false) }}
                    submitting={submitting}
                />
            ) : (
                <Typography variant="body1">
                    <HtmlView value={
                        locale === 'en'
                            ? otherRequirementStepInfo?.[currentStepName]?.otherRequirementInformationEn
                            : otherRequirementStepInfo?.[currentStepName]?.otherRequirementInformationSv
                    } />
                </Typography>
            )}
        </Panel>
    );
};

const EvaluationForm = ({
    editingData,
    submit,
    cancelEdit,
    submitting,
}: {
    editingData: any;
    submit: any;
    cancelEdit: () => void;
    submitting?: boolean;
}) => {
    const { formatMessage } = useIntl();

    const chapterSv = useFormField({
        label: formatMessage({
            id: 'admin.law-portal.informationBoard.form.message.label.sv',
            defaultMessage: 'Message (Swedish)',
        }),
        name: 'otherRequirementInformationSv',
        type: 'rich-text',
        required: false,
        richTextEditorHeight: 'small',
        initialState: editingData?.otherRequirementInformationSv
            ? { value: editingData.otherRequirementInformationSv, label: editingData.otherRequirementInformationSv, isValid: true }
            : undefined,
    });

    const chapterEn = useFormField({
        label: formatMessage({
            id: 'admin.law-portal.informationBoard.form.message.label.en',
            defaultMessage: 'Message (English)',
        }),
        name: 'otherRequirementInformationEn',
        type: 'rich-text',
        required: false,
        richTextEditorHeight: 'small',
        initialState: editingData?.otherRequirementInformationEn
            ? { value: editingData.otherRequirementInformationEn, label: editingData.otherRequirementInformationEn, isValid: true }
            : undefined,
    });

    return (
        <Form
            submit={submit}
            cancel={cancelEdit}
            groups={[{ grid: { type: 'column', items: [chapterSv, chapterEn] } }]}
        />
    );
};

export default OtherRequirementInfo;
